import { TDatesModalActions } from './datesModal';
import { TModifier } from '../../../../packages/Filters';
import { TJsonQuery } from '../../../../packages/JsonQuery';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { TTag } from '../../types/tags';

export enum ETagsActionType {
  Loading = 'filters/tags/loading',
  Succeed = 'filters/tags/succeed',
  Failed = 'filters/tags/failed',
  Removed = 'filters/tags/removed',
  RemoveAllTags = 'filters/tags/removeAllTags',
}

export enum EFiltersActionType {
  JsonQueryChanged = 'filters/jsonQuery/changed',
  ChangeJsonQuery = 'filters/changeJsonQuery,',
}

export interface IJsonQueryChanged {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  appliedModifiers: [TModifier, ...TModifier[]];
  prevJsonQuery: TJsonQuery;
  nextJsonQuery: TJsonQuery;
}

export interface IChangeJsonQuery {
  nextJsonQuery: TJsonQuery;
}

export type TJsonQueryChangedAction = ITypedReduxAction<EFiltersActionType.JsonQueryChanged, IJsonQueryChanged>;
export type TFetchTagsLoading = ITypedReduxAction<ETagsActionType.Loading>;
export type TFetchTagsSucceed = ITypedReduxAction<ETagsActionType.Succeed, TTag[] | null>;
export type TFetchTagsFailed = ITypedReduxAction<ETagsActionType.Failed>;
export type TTagRemoved = ITypedReduxAction<ETagsActionType.Removed, TTag>;
export type TRemoveAllTags = ITypedReduxAction<ETagsActionType.RemoveAllTags>;
export type TChangeJsonQuery = ITypedReduxAction<EFiltersActionType.ChangeJsonQuery, IChangeJsonQuery>;

export type TFiltersActions =
  | TJsonQueryChangedAction
  | TFetchTagsLoading
  | TFetchTagsSucceed
  | TFetchTagsFailed
  | TTagRemoved
  | TRemoveAllTags
  | TChangeJsonQuery
  | TDatesModalActions;
